<template>
  <div class="page flexcolumn">
    <div class="jp-common-layout ">
      <!-- <div class="jp-common-layout-left" style="width: 370px;">
        <div class="jp-common-hearde mt8">
          <el-card class="box-card" style="width: 350px;">
            <div slot="header" class="clearfix" style="line-height: 20px;">
              <span class="fontbold fs14">空间基本信息</span>
            </div>
            <div>
              <el-form ref="form" :model="setsDetForm" label-width="120px">
                <el-form-item label="空间名称：">
                  <span class="fontbold">{{ setsDetForm.nameCn }}</span>
                </el-form-item>
                <el-form-item label="关联套餐名称：">
                  <span class="fontbold">{{ setsDetForm.setsObj.nameCn }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
      </div> -->
      <div class="jp-common-layout-center jp-flex-main">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
          <!-- 搜索框-->
          <el-form-item prop="storeyId">
            <el-select
              v-model="storeyValue"
              clearable
              filterable 
              placeholder="楼层"
              style="width: 180px"
              @change="handSelect($event, 'storeyId')"
            >
              <el-option
                v-for="item in $dictUtils.getDictList('cec_storey')"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="roomId">
            <el-select
              v-model="roomValue"
              filterable 
              clearable
              placeholder="空间"
              style="width: 180px"
              @change="handSelect($event, 'roomId')"
            >
              <el-option
                v-for="item in $dictUtils.getDictList('cec_room')"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="positionId">
            <el-select
              v-model="positionValue"
              filterable 
              clearable
              placeholder="位置"
              style="width: 180px"
              @change="handSelect($event, 'positionId')"
            >
              <el-option
                v-for="item in $dictUtils.getDictList('cec_pos')"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item prop="proCode">
            <el-input size="small" v-model="searchForm.proCode" placeholder="项目编号" clearable></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input size="small" v-model="searchForm.name" placeholder="项目名称" clearable></el-input>
          </el-form-item>
          <el-form-item prop="kindId1">
            <el-select
              v-model="searchForm.kindId1"
              clearable
              filterable
              placeholder="工程类别"
              style="width: 180px"
              @change="handCategories"
            >
              <el-option
                v-for="item in kindCategoriesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="kindId2">
            <el-select
              v-model="searchForm.kindId2"
              clearable
              filterable
              placeholder="工程类型"
              style="width: 180px"
            >
              <el-option
                v-for="item in kindTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="bg-white top">
          <vxe-toolbar >
            <template #buttons>
              <!-- <el-button v-if="hasPermission('unmspace:cecUnmSpace:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">添加项目</el-button> -->
              <GridSelect
                ref="gridselectRef"
                title="添加项目"
                labelName = 'name'
                :disabled="false"
                :showPagination="true"
                dialogWidth="80%"
                showType="none"
                labelValue = 'id'
                :value = "spaceListIdsNew"
                :limit="100"
                @getValue='getValueGridProject'
                @clearParame="resetSearch"
                :columns="[
                {
                  prop: 'proCode',
                  label: '项目编号'
                },
                {
                  prop: 'name',
                  label: '项目名称'
                },
                {
                  prop: 'kindName1',
                  label: '工程类别'
                },
                {
                  prop: 'kindName2',
                  label: '工程类型'
                },
                {
                  prop: 'image',
                  width: '50',
                  label: '图片'
                },
                ]"
                :searchs="[
                {
                  prop: 'proCode',
                  label: '项目编号',
                },
                {
                  prop: 'name',
                  label: '项目名称'
                },
                {
                  option: kindCategoriesList,
                  prop: 'kindId1',
                  label: '工程类别'
                },
                {
                  prop: 'kindId2',
                  label: '工程类型'
                }
                ]"
                dataListUrl="/unmprojectpositionproject/cecUnmProjectPositionProject/list"
                queryEntityUrl="/unmprojectpositionproject/cecUnmProjectPositionProject/queryById"
                :params="{
                  projectSetsId: setsDetForm.projectSetsId,
                  orders: [{ column: 'a.create_date', asc: true }],
                  roomId: setsDetForm.setsPositionId,
                  storeyId: '',
                  positionId: '',
                }"
                >
              </GridSelect>
              <!-- <el-button v-if="hasPermission('unmspace:cecUnmSpace:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmSetsProjectTable && $refs.cecUnmSetsProjectTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
              <!-- <el-button v-if="hasPermission('unmspace:cecUnmSpace:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmSetsProjectTable && $refs.cecUnmSetsProjectTable.getCheckboxRecords().length === 0" plain>删除</el-button> -->
            </template>
          </vxe-toolbar>
          <div style="height: calc(100% - 80px);">
            <vxe-table
              border="full"
              auto-resize
              resizable
              height="100%"
              :loading="loading"
              size="small"
              ref="cecUnmSetsProjectTable"
              show-header-overflow
              show-overflow
              highlight-hover-row
              :menu-config="{}"
              :print-config="{}"
              :import-config="{
              importMethod: importMethod,
                  types: ['csv', 'xls', 'xlsx'],
                  remote: true,
              }"
              :export-config="{
                  remote: true,
                  filename: `空间表数据${moment(new Date()).format(
                  'YYYY-MM-DD'
                  )}`,
                  sheetName: '空间表数据',
                  exportMethod: exportMethod,
                  types: ['xlsx'],
                  modes: ['current', 'selected', 'all'],
              }"
              @sort-change="sortChangeHandle"
              :sort-config="{remote:true}"
              :data="dataList"
              :checkbox-config="{}">
              <!-- <vxe-column type="checkbox"  width="40px" align="center" fixed="left"></vxe-column> -->
            <vxe-column type="seq" width="50" fixed="left" align="center" title="序号"></vxe-column>
            <!-- <vxe-column
        field="isFinish"
        fixed="left"
        align="center"
        width="80"
        title="配置状态">
        <template slot-scope="scope">
          <i v-if="scope.row.project.isFinish == '1'" class="el-icon-check isFinishIcon colorGreen" ></i>
          <i v-else class="el-icon-close isFinishIcon colorRed" ></i>
        </template>
      </vxe-column> -->
      <vxe-column
        field="proCode"
        fixed="left"
        align="center"
        width="100"
        title="项目编号">
              <template slot-scope="scope">
                <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmprojectpositionproject:cecUnmProjectPositionProject:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:view')"  @click="view(scope.row)">{{scope.row.project.proCode}}</el-link>
                <span v-else>{{scope.row.project.proCode}}</span>
              </template>
      </vxe-column>
      <vxe-column
        field="isSelected"
        width="100"
        align="center"
        title="默认显示">
        <template slot-scope="scope">
              <!-- {{ $dictUtils.getDictLabel("show_hide", scope.row.state, '-') }} -->
                    <el-switch
                      v-if="scope.row.id != '0'"
                      v-model="scope.row.isSelected"
                      @change="isSelectedChange(scope.row)"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0">
                    </el-switch>
        </template>
      </vxe-column>
      <vxe-column
        field="name"
        fixed="left"
        align="center"
        width="150"
        title="项目名称">
        <template slot-scope="scope">
          <span>{{ scope.row.project.name }}</span>
        </template>
      </vxe-column>
      <vxe-column
        field="kindName1"
        width="150"
        align="center"
        title="工程类别">
        <template slot-scope="scope">
          <span>{{ scope.row.project.kindName1 }}</span>
        </template>
      </vxe-column>
    <vxe-column
        field="kindName2"
        width="150"
        align="center"
        title="工程类型">
        <template slot-scope="scope">
          <span>{{ scope.row.project.kindName2 }}</span>
        </template>
      </vxe-column>
      <vxe-column
          field="storeyId"
          align="center"
          width="100"
          title="楼层">
          <template slot-scope="scope">
          <span>{{ scope.row.storey ? scope.row.storey.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="roomId"
          align="center"
          width="100"
          title="空间">
          <template slot-scope="scope">
          <span>{{ scope.row.room ? scope.row.room.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="positionId"
          align="center"
          width="150"
          title="位置">
          <template slot-scope="scope">
          <span>{{ scope.row.position ? scope.row.position.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="num"
          align="center"
          width="100"
          title="数量/面积">
        </vxe-column>
        <vxe-column
          field="unitId"
          align="center"
          width="100"
          title="单位">
          <template slot-scope="scope">
            <span>{{ scope.row.project.unit ? scope.row.project.unit.unitEn : '' }}</span>
          </template>
        </vxe-column>
      <vxe-column
          field="price"
          align="center"
          width="100"
          title="项目单价">
          <template slot-scope="scope">
            <div class="flexBetween">
              <span>$</span>
              <span>{{  $mathUtil.mathToFixed(scope.row.price) }}</span>
            </div>
          </template>
        </vxe-column>
      <vxe-column
          field="totalPrice"
          align="center"
          width="100"
          title="项目总价">
          <template slot-scope="scope">
            <div class="flexBetween">
              <span>$</span>
              <span>{{  $mathUtil.mathToFixed(scope.row.totalPrice) }}</span>
            </div>
          </template>
        </vxe-column>
      <vxe-column
          field="description"
          align="center"
          min-width="100"
          title="备注">
        </vxe-column>
      <!-- <vxe-column
          field="makeupId"
          align="center"
          width="100"
          title="材料方案id">
        </vxe-column>
        <vxe-column
          field="linkProjectId"
          align="center"
          width="100"
          title="关联项目">
        </vxe-column> -->
            <!-- <vxe-column
              fixed="right"
              align="center"
              width="200"
              title="操作">
              <template  slot-scope="scope">
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
              </template>
            </vxe-column> -->
          </vxe-table>
          <vxe-pager
            background
            size="small"
            :current-page="tablePage.currentPage"
            :page-size="tablePage.pageSize"
            :total="tablePage.total"
            :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="currentChangeHandle">
          </vxe-pager>
        </div>
        </div>
          <!-- 弹窗, 新增 / 修改 -->
      </div>
    </div>
  </div>
</template>

<script>
  // import CecUnmSpaceForm from './CecUnmSpaceForm'
  import GridSelect from '@/components/gridSelect/setTagTableSet2.vue'
  import PopoverTip from '@/components/popoverTip'
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  import cecProjectKindService from '@/api/cecprojectkind/cecProjectKindService'
  import SetMealPositionService from '@/api/cecunmsetmealposition/cecUnmSetMealPositionService'
  import cecUnmProjectPositionService from '@/api/unmprojectposition/cecUnmProjectPositionService'
  import csmpProjectService from '@/api/cecunmsetmealpositionproject/cecUnmSetMealPositionProjectService'
  import cecUnmPositionService from '@/api/cecunmposition/cecUnmPositionService'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          name: '',
          projectIdsStr: '',
          spaceIdsStr: '',
          type: '',
          storeyId: '',
          roomId: '',
          positionId: '',
          proCode: '',
          kindId1: '',
          kindId2: '',
          setsPositionId: ''
        },
        setsDetForm: {
          nameCn: '',
          nameEn: '',
          targetPrice: '',
          setsObj: {
            nameCn: ''
          }
        },
        oldRow: null,
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: true }]
        },
        loading: false,
        treeLoading: false,
        filterText: '',
        officeTreeData: [],
        showTreeList: [],
        projectSetsId: '',
        treeExpandAll: false,
        storeyValue: '',
        roomValue: '',
        positionValue: '',
        kindCategoriesList: [],
        kindTypeList: [],
        defaultExpandRowKeys: [],
        spaceTreeIdsNew: '',
        spaceTreeIdsOld: '',
        spaceListIdsNew: ''
      }
    },
    components: {
      GridSelect,
      PopoverTip,
      PopoverTipList
    },
    activated () {
      // this.clearSearchData()
      this.projectSetsId = this.$route.query.id
      this.getProjectKind('Categories', '0')
      this.getSetsProject()
      // this.getTreeList()
    },
    watch: {
      // storeyValue (val) {
      //   let findPositionData = this.officeTreeData.find(item => item.dictValueId === val)
      //   this.searchForm.storeyId = findPositionData ? findPositionData.id : val
      // }
    },
    methods: {
      isSelectedChange (data) {
        this.loading = true
        let query = {
          id: data.id,
          isSelected: data.isSelected
        }
        csmpProjectService.save(query).then(({data}) => {
          this.$message.success(data)
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 添加套餐回调
      getValueGridProject (e) {
        this.loading = true
        let query = {
          ids: e,
          sestId: this.projectSetsId,
          storeyId: this.searchForm.storeyId,
          roomId: this.searchForm.roomId,
          positionId: this.searchForm.positionId
        }
        csmpProjectService.savePtProjectIds(query).then(({data}) => {
          this.refreshList()
          // this.getTreeList('none')
        })
      },
      // 新增套餐空间
      getValueGrid (e) {
        this.treeLoading = true
        let query = {
          ids: e,
          sestId: this.projectSetsId
        }
        SetMealPositionService.savePositionIds(query).then(({data}) => {
          // this.inputForm = this.recover(this.inputForm, data)
          // this.loading = false
          this.getTreeList()
        })
      },
      // 获取工程类型和类别
      getProjectKind (type, pid) {
        cecProjectKindService.getKindList(
          {
            parentId: pid,
            orders: [{ column: 'sort', asc: true }]
          }
        ).then(({data}) => {
          if (type === 'Categories') {
            this.kindCategoriesList = data
          } else {
            this.kindTypeList = data
          }
        })
      },
      // 工程类别事件处理
      handCategories (e) {
        if (e) {
          this.getProjectKind('type', e)
        } else {
          this.kindTypeList = []
        }
        this.searchForm.kindId2 = ''
      },
      // 获取套餐详情
      getSetsProject () {
        cecUnmPositionService.queryById(this.projectSetsId).then(({data}) => {
          this.setsDetForm = data
          this.getSetsMealPositionDet(data.setsPositionId)
        })
      },
      getSetsMealPositionDet (id) {
        cecUnmProjectPositionService.queryById(id).then(({data}) => {
          // 保存关联空间，保证后续重置搜索回显
          this.oldRow = data
          this.handRow(data)
        })
      },
      handSelect (e, type) {
        if (type === 'storeyId') {
          if (e === '') {
            this.searchForm.storeyId = ''
          } else {
            this.searchForm.storeyId = e
          }
          this.searchForm.roomId = ''
          this.searchForm.positionId = ''
          this.roomValue = ''
          this.positionValue = ''
        } else if (type === 'roomId') {
          if (e === '') {
            this.searchForm.roomId = ''
          } else {
            this.searchForm.roomId = e
          }
          this.searchForm.positionId = ''
          this.positionValue = ''
        } else {
          if (e === '') {
            this.searchForm.positionId = ''
          } else {
            this.searchForm.positionId = e
          }
        }
      },
      // 点击树结构
      handRow (row, type) {
        this.oldRow = row
        if (row.grade === '1') {
          this.searchForm.storeyId = row.id
          this.searchForm.roomId = ''
          this.storeyValue = row.dictValueId
          this.roomValue = ''
          this.positionValue = ''
          this.searchForm.positionId = ''
        } else if (row.grade === '2') {
          this.storeyValue = ''
          this.searchForm.roomId = row.id
          this.roomValue = row.dictValueId
          this.positionValue = ''
          this.searchForm.positionId = ''
        } else {
          // let gradeTwoData = this.officeTreeData.find(item => item.id === row.id)
          this.storeyValue = ''
          this.searchForm.storeyId = ''
          this.roomValue = ''
          this.searchForm.roomId = ''
          this.searchForm.positionId = row.id
          this.positionValue = row.dictValueId
        }
        // if (type === 'row') {
        this.refreshList()
        // }
      },
      // 展开和搜索树结构
      searchTree (type) {
        if (type === 'expandAll') {
          this.treeExpandAll = !this.treeExpandAll
          this.$refs.xTree.setAllTreeExpand(this.treeExpandAll)
        } else if (type === 'search') {
          let parentList = []
          if (this.filterText) {
            let filerData = this.officeTreeData.filter(item => item.nameCn.indexOf(this.filterText) >= 0)
            filerData.forEach(item => {
              let findDate = this.officeTreeData.find(fitem => fitem.id === item.parentId)
              if (findDate) {
                parentList.push(findDate)
              }
            })
            let filterList = [...filerData, ...parentList]
            this.showTreeList = filterList
            this.$refs.xTree.setAllTreeExpand(true)
          } else {
            this.showTreeList = this.officeTreeData
          }
        }
      },
      filterNode (value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      renderContent (h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span class="text">{node.label}</span>
          </span>
        )
      },
      handleNodeClick (data) {
        if (data.id === '') {
          this.searchForm.type = ''
        } else {
          this.searchForm.type = data.id
        }
        this.refreshList()
      },
      // 获取树结构
      getTreeList (type) {
        this.treeLoading = true
        SetMealPositionService.allList({
          projectSetsId: this.projectSetsId,
          orders: [{ column: 'sort', asc: true }]
        }).then(({data}) => {
          this.officeTreeData = data
          let filterList = data.filter(item => item.parentId === '0')
          if (filterList.length === 1) {
            this.defaultExpandRowKeys.push(filterList[0].id)
          }
          this.$nextTick(() => {
            // this.showTreeList = data
            this.$refs.xTree.reloadData(data)
            if (data.length === 1 || data.length > 1) {
              if (!this.oldRow) {
                this.defaultExpandRowKeys.push(data[0].id)
                this.$refs.xTree.setCurrentRow(data[0])
                this.handRow(data[0])
              } else {
                let dataFind = data.find(item => item.id === this.oldRow.id)
                if (dataFind) {
                  let defaultExpandRowKeysIds = this.oldRow.parentId === '0' ? [this.oldRow.id] : [this.oldRow.parentId, this.oldRow.id]
                  this.defaultExpandRowKeys = defaultExpandRowKeysIds
                  this.$refs.xTree.setCurrentRow(dataFind)
                  this.handRow(this.oldRow)
                } else {
                  this.defaultExpandRowKeys.push(data[0].id)
                  this.$refs.xTree.setCurrentRow(data[0])
                  this.handRow(data[0])
                }
              }
            } else {
              this.dataList = []
              this.storeyId = ''
              this.roomValue = ''
              this.positionValue = ''
            }
            this.treeExpandAll = true
          })
          this.spaceTreeIdsNew = data.length > 0 ? data.map(item => item.oldPositionId).join(',') : ''
          this.spaceTreeIdsOld = data.length > 0 ? data.map(item => item.oldPositionId).join(',') : ''
          this.treeLoading = false
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        csmpProjectService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          projectSetsId: this.projectSetsId,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          // this.spaceListIdsNew = data.records.length > 0 ? data.records.map(item => item.oldProjectId).join(',') : ''
          this.tablePage.total = data.total
          this.loading = false
        })
        csmpProjectService.getAllSelectIds({
          projectSetsId: this.projectSetsId,
          ...this.searchForm
        }).then(({data}) => {
          this.spaceListIdsNew = data
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmProjectPositionProjectForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmSetsProjectTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmProjectPositionProjectForm.init('edit', id)
      },
      // 查看
      view (data) {
        // this.$refs.cecUnmProjectPositionProjectForm.init('view', uid)
        this.$router.push({path: '/cecunmsetmeal/CecUnmSetsMealProjectDet', query: {id: data.id, title: '套餐' + data.proCode + '<详情>'}})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSetsProjectTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          csmpProjectService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        csmpProjectService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        csmpProjectService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return csmpProjectService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      clearSearchData () {
        this.$refs.searchForm.resetFields()
        this.roomValue = ''
        this.storeyValue = ''
        this.positionValue = ''
        this.defaultExpandRowKeys = []
        // this.showTreeList = []
        // this.oldRow = null
      },
      resetSearch () {
        this.clearSearchData()
        if (!this.handRow === false) {
          this.handRow(this.oldRow)
        } else {
          this.refreshList()
        }
      }
    }
  }
</script>
<style scoped >
::v-deep .jp-common-layout-left .vxe-body--column{
  height: 35px !important;
  cursor: pointer;
}
.jp-common-hearde{
    /* padding: 10px; */
    background-color: #fff;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-bottom: 10px;
}
.flexcolumn{
  display: flex;
  flex-direction: column;
}
::v-deep .jp-common-hearde .el-card__header {
    padding: 10px 20px !important;
}
::v-deep .jp-common-hearde .el-form-item__label {
    line-height: 22px;
}
::v-deep .jp-common-hearde .el-form-item__content {
    line-height: 22px;
}
::v-deep .jp-common-hearde .el-form-item {
    margin-bottom: 0;
}
::v-deep .jp-common-hearde .el-form-item label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
}
::v-deep .jp-common-hearde .el-card__body {
    padding-top: 10px !important;
}
.fontbold{
  font-weight: bold;
}
.fs14{
  font-size: 14px;
}
.flexTreeTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-scrollbar__view  .vxe-body--row.row--current {
    background-color: #ffd991 !important;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
